import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../MastersHub.css';

/**
 * MasterPageWrapper
 * Enterprise wrapper component providing:
 * - Structured breadcrumb navigation
 * - Header with Title and primary action button (toggle between Form & List)
 * - Clean view-mode switching
 */
export const MasterPageWrapper = ({
  masterTitle,
  masterName,
  viewMode = 'form', // 'form' | 'list'
  onToggleView,
  breadcrumbItems = [],
  actions,
  children
}) => {
  const navigate = useNavigate();

  return (
    <div className="page-container fade-in">
      {/* Breadcrumb Area */}
      <div className="breadcrumb">
        <button type="button" onClick={() => navigate('/dashboard')}>
          Home
        </button>
        <span className="breadcrumb-divider">/</span>
        <button type="button" onClick={() => navigate('/masters')}>
          Masters
        </button>
        <span className="breadcrumb-divider">/</span>
        <span style={{ color: viewMode === 'list' ? 'var(--text-primary)' : 'var(--text-muted)' }}>
          {masterName || masterTitle}
        </span>
        <span className="breadcrumb-divider">/</span>
        <span className="breadcrumb-active">
          {viewMode === 'form' ? 'Form' : 'List'}
        </span>
      </div>

      {/* Page Header with Action Button */}
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
        <div className="page-title-group">
          <h1 className="page-title">
            {masterTitle}
          </h1>
          <span className="page-subtitle">
            {viewMode === 'form'
              ? `Fill in the details below to configure ${masterName || 'this master record'}.`
              : `Directory of all registered ${masterName || 'records'} with status and management actions.`}
          </span>
        </div>

        {actions ? (
          <div className="master-header-actions" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            {actions}
          </div>
        ) : onToggleView && (
          <div>
            {viewMode === 'form' ? (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => onToggleView('list')}
                id="master-toggle-view-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.55rem 1.15rem'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="8" y1="6" x2="21" y2="6" />
                  <line x1="8" y1="12" x2="21" y2="12" />
                  <line x1="8" y1="18" x2="21" y2="18" />
                  <line x1="3" y1="6" x2="3.01" y2="6" />
                  <line x1="3" y1="12" x2="3.01" y2="12" />
                  <line x1="3" y1="18" x2="3.01" y2="18" />
                </svg>
                <span>View {masterName ? `${masterName}s` : 'List'}</span>
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => onToggleView('form')}
                id="master-toggle-form-btn"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.55rem 1.15rem'
                }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                <span>Add {masterName || 'Record'}</span>
              </button>
            )}
          </div>
        )}
      </div>

      {/* Main Workspace */}
      <div className="master-content-body">
        {children}
      </div>
    </div>
  );
};

export default MasterPageWrapper;
